import React from 'react';
import WmsDesktopLayout from "../../wmsDesktopLayout";
import {FormattedMessage} from "react-intl";
import PageTitle from "../../../../components/WMS/Mobile/PageTitle";
import {Grid} from "@mui/material";
import CreatePickingMissionForm from "../components/CreatePickingMissionForm";

function CreatePickingMissionDesktopContainer() {

    return (
        <WmsDesktopLayout>
            <WmsDesktopLayout.Content>
                <Grid
                    container
                    direction={'column'}
                    gap={'8px'}
                    sx={{height: '100%'}}
                >
                    <Grid container gap={"48px"}>
                        <PageTitle
                            isDesktop
                            title={<FormattedMessage id={"wms.newPickingMission.title"}/>}
                            subtitle={<FormattedMessage id={"wms.newPickingMission.subtitle"}/>}
                        />
                    </Grid>

                    <CreatePickingMissionForm/>
                </Grid>
            </WmsDesktopLayout.Content>
        </WmsDesktopLayout>
    );
}

export default CreatePickingMissionDesktopContainer;